const HTML_TAG = /<[^>]*>/g;
/** `&nbsp;` and `&#160;`, the blank entities the rich text editor writes into empty paragraphs. */
const NON_BREAKING_SPACE_ENTITY = /&nbsp;|&#160;/gi;
const VISIBLE_CHARACTER = /\S/;

/**
 * True when rich text (HTML from the editor) contains visible characters, e.g. false for
 * `<p>&nbsp;</p>` and whitespace, true for `<p>x</p>`.
 * @param {string|null|undefined} html
 * @returns {boolean}
 */
export const hasVisibleText = (html) => {
  if (!html) {
    return false;
  }

  const text = html.replace(HTML_TAG, '').replace(NON_BREAKING_SPACE_ENTITY, ' ');

  return VISIBLE_CHARACTER.test(text);
};
